module.exports = __webpack_public_path__ + "img/share-wechat.e4e9ccd0.png";